import styled from "styled-components";
import MaskedTextInput from "react-text-mask";

export const InputGroup = styled("div")(({ theme }) => ({
  width: "100%",
}));

export const Label = styled("label")(({ theme }) => ({
  width: "100%",
  fontSize: 10,
  paddingLeft: 15,
  paddingTop: 2,
  color: theme.palette.input.labelText,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  [theme.down("sm")]: {
    fontSize: 9,
    paddingLeft: 12,
  },
}));

export const InputBlock = styled("div")(({ theme, isError, isSuccess }) => ({
  ...theme.mixins.flexColumn,
  position: "relative",
  height: 50,
  borderRadius: 4,
  border: `1px solid ${isError ? theme.palette.input.borderError : theme.palette.input.border}`,
  ...(isSuccess ? { borderLeftWidth: 3, borderLeftColor: theme.palette.input.borderSuccess } : {}),
  ...(isError ? { backgroundColor: theme.palette.input.errorBg } : {}),
  transition: "all .2s ease",

  "&:focus-within": {
    borderColor: isError ? theme.palette.input.borderError : theme.palette.input.borderFocus,
    boxShadow: isError
      ? `0 0 0 3px ${theme.palette.input.errorShadow}`
      : `0 0 0 3px ${theme.palette.input.focusShadow}`,
  },
}));

export const InputElement = styled("input")(({ theme }) => ({
  ...theme.paddings(10, 30, 0, 15),
  position: "absolute",
  width: "100%",
  height: "100%",
  border: "none",
  lineHeight: 1,
  backgroundColor: "transparent",
  fontSize: 16,

  "&:hover, &:active, &:focus": {
    outline: "none",
  },

  "&::placeholder": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  [theme.down("sm")]: {
    // FE-27: 16px обязателен — при меньшем размере iOS зумит страницу на фокусе
    fontSize: 16,
    ...theme.paddings(10, 15, 0, 12),

    "&::placeholder": {
      fontSize: 13,
    },
  },
}));

export const MaskedInputElement = styled(MaskedTextInput)(({ theme }) => ({
  ...theme.paddings(10, 30, 0, 15),
  position: "absolute",
  width: "100%",
  height: "100%",
  border: "none",
  lineHeight: 1,
  backgroundColor: "transparent",
  fontSize: 16,

  "&:hover, &:active, &:focus": {
    outline: "none",
  },

  "&::placeholder": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  [theme.down("sm")]: {
    // FE-27: 16px обязателен — при меньшем размере iOS зумит страницу на фокусе
    fontSize: 16,
    ...theme.paddings(10, 15, 0, 12),

    "&::placeholder": {
      fontSize: 13,
    },
  },
}));

export const Error = styled("div")(({ theme, $visible }) => ({
  // FE-26: слот под ошибку существует всегда — иначе форма прыгает при валидации
  minHeight: 20,
  marginTop: 4,
  color: theme.palette.input.errorText,
  fontSize: 14,
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: 4,
  opacity: $visible ? 1 : 0,
  transform: $visible ? "translateY(0)" : "translateY(-4px)",
  transition: "opacity .2s ease-out, transform .2s ease-out",

  [theme.down("sm")]: {
    fontSize: 13,
    minHeight: 18,
  },
}));
